export default class Payload {
    
    constructor(selection, data) {

      this.selection = selection;
      this.data = data;

    }
    
  }